export const validatorsApiPaths = {
  deleteUser: (userId: string) => `user-management/delete-requests/candidates/${userId}`,
  deleteCompany: (companyId: string) => `user-management/delete-company-and-accounts/${companyId}`,
  deleteWiki: (wikiId: string) => `wiki/${wikiId}`,
}
